import { breakpoints, vars } from '@etg/wings';
import { css } from '@eti/styles';
export const productWrapperStyles = upsellHighlight => css`
  ${upsellHighlight && `border: 2px solid ${vars.colors.promotional.foreground}`};
  border-radius: ${vars.card.borderRadius};
  font-size: 0.875rem;
  overflow-wrap: break-word;
  padding: 0;
  word-break: normal;
`;
export const standardGrid = css`
  display: grid;
  gap: 16px 0;
  grid-template-columns: 0 1fr;
  grid-template-rows: repeat(4, auto);
  padding: 16px;

  .illustration {
    grid-area: 1 / 1 / 5 / 2;
  }

  .header {
    grid-area: 1 / 2 / 2 / 3;
  }

  .body {
    grid-area: 2 / 2 / 3 / 3;
  }

  .readMore {
    grid-area: 3 / 2 / 4 / 3;
  }

  .cta {
    grid-area: 4 / 2 / 5 / 3;

    &:not(:has(legend)) {
      .buttonWrapper {
        margin-top: 22px;

        @media (min-width: ${breakpoints._768}) {
          margin-top: 0;
        }
      }

      .priceLabel {
        margin-top: 8px;
      }
    }

    &:has(.addToCartButtonWrapper) .priceLabel {
      margin-inline-start: 0;

      @media (min-width: ${breakpoints._768}) {
        margin-inline-start: auto;
      }
    }
  }

  .children {
    display: contents;
  }

  @media (min-width: ${breakpoints._768}) {
    column-gap: 16px;
    grid-template-columns: 3fr 7fr;
  }
`;
//# sourceMappingURL=styles.js.map